import { gql } from '@apollo/client'

export const AccommodationQuery = gql`
  query Accommodation($companyId: ID!, $filters: AccommodationFilters) {
    accommodations(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        address
        name
      }
    }
  }
`
